import {
  BookOpenCheck,
  Building2,
  FileSignature,
  Landmark,
  Receipt,
  ShieldCheck,
  UserCircle2,
} from "lucide-react";
import type { CertificateType } from "@/lib/mock";
import { cn } from "@/lib/cn";

const map: Record<
  CertificateType,
  { icon: typeof FileSignature; bg: string; fg: string }
> = {
  firma_natural: { icon: UserCircle2, bg: "bg-brand-50", fg: "text-brand-700" },
  firma_natural_rut: { icon: UserCircle2, bg: "bg-cyan-50", fg: "text-cyan-700" },
  firma_representante: { icon: FileSignature, bg: "bg-indigo-50", fg: "text-indigo-700" },
  firma_juridica: { icon: Building2, bg: "bg-violet-50", fg: "text-violet-700" },
  facturacion: { icon: Receipt, bg: "bg-emerald-50", fg: "text-emerald-700" },
  funcion_publica: { icon: Landmark, bg: "bg-amber-50", fg: "text-amber-700" },
  profesional: { icon: ShieldCheck, bg: "bg-sky-50", fg: "text-sky-700" },
  funcion_publica_siif: { icon: Landmark, bg: "bg-orange-50", fg: "text-orange-700" },
  comunidad_academica: { icon: BookOpenCheck, bg: "bg-rose-50", fg: "text-rose-700" },
};

export function CertificateTypeIcon({
  type,
  size = "md",
  className,
}: {
  type: CertificateType;
  size?: "sm" | "md" | "lg";
  className?: string;
}) {
  const { icon: Icon, bg, fg } = map[type];
  const box = size === "sm" ? "h-9 w-9" : size === "lg" ? "h-14 w-14" : "h-11 w-11";
  const iconSize = size === "sm" ? "h-4 w-4" : size === "lg" ? "h-7 w-7" : "h-5 w-5";
  return (
    <span className={cn("inline-flex flex-none items-center justify-center rounded-2xl", box, bg, fg, className)}>
      <Icon className={iconSize} />
    </span>
  );
}
